export const formatDistanceToNow = (t, date) => {
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);

    const intervals = [
        { label: 'year', seconds: 31536000 },
        { label: 'month', seconds: 2592000 },
        { label: 'week', seconds: 604800 },
        { label: 'day', seconds: 86400 },
        { label: 'hour', seconds: 3600 },
        { label: 'minute', seconds: 60 },
        { label: 'second', seconds: 1 },
    ];

    for (const interval of intervals) {
        const count = Math.floor(seconds / interval.seconds);
        if (count >= 1) {
            const time = `${count} ${t(`myStories.${interval.label}`)}${count !== 1 && t(`myStories.${interval.label}`).at(-1) !== 's' ? 's' : ''}`;    
            return t('myStories.timeAgo', {time: time});
        }
    }
    return t('myStories.justNow');
};

export const isoDateDifference = (isoDate) => {
    const inputDate = new Date(isoDate);
    const now = new Date();
    const diff = now - inputDate;

    return (diff / (1000 * 60 * 60 * 24)); // in days
}

export const formatDate = (d) => {
  const userLocale = navigator.language || "en-US"; // Default to English if locale is not found
  return (new Intl.DateTimeFormat(userLocale, {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(new Date(d)));
}

export const formatDateTime = (d) => {
  const userLocale = navigator.language || "en-US"; // Default to English if locale is not found
  return (new Intl.DateTimeFormat(userLocale, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  }).format(new Date(d)));
}